import { useMediaQuery, useTheme } from '@mui/material';
import { useOpenMenuItemDialogPath } from 'hooks/dialog/menu-dialog.hooks';
import { useDisplayInfo } from 'hooks/useDisplayInfo';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  makeSelectCatalog,
  makeSelectIsItemOutOfStock,
} from 'redux/catalogs/catalogs.selectors';
import MenuCardNewImage from '../menu-card-new-image/menu-card-new-image.component';
import MenuCardNew from '../menu-card-new.component';
import MenuCardNewItemContent from './menu-card-new-item-content/menu-card-new-item-content.component';
import * as S from './menu-card-new-item.styles';

const MenuCardNewItem = ({ item, catalogId, path, ...rest }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const { smallImage, title, shortDescription } = useDisplayInfo(
    item.displayInfo,
  );

  const openModal = useOpenMenuItemDialogPath(path);

  // eslint-disable-next-line
  const selectIsItemOutOfStock = useCallback(
    makeSelectIsItemOutOfStock(item.itemId),
  );

  const isItemOutOfStock = useSelector(selectIsItemOutOfStock);
  const { t } = useTranslation();

  const catalogSelector = useMemo(
    () => makeSelectCatalog(catalogId),
    [catalogId],
  );
  const catalog = useSelector(catalogSelector);

  const handlePressedOpenModal = event => {
    const code = event.keyCode || event.which;
    if (code === 13) {
      //13 is the enter keycode
      openModal();
    }
  };

  return (
    <MenuCardNew
      onClick={openModal}
      onKeyPress={handlePressedOpenModal}
      disabled={isItemOutOfStock}
      {...rest}
    >
      {isItemOutOfStock && (
        <S.NotAvailableBadge>
          {t('catalog.itemNotAvailable')}
        </S.NotAvailableBadge>
      )}
      {matches ? (
        <S.Container>
          <MenuCardNewImage smallImage={smallImage} />
          <MenuCardNewItemContent
            title={title}
            description={shortDescription}
            price={item.price}
            calories={item.calories}
            catalogExtendedAttributes={catalog?.extendedAttributes}
          />
        </S.Container>
      ) : (
        <>
          <MenuCardNewImage smallImage={smallImage} />
          <MenuCardNewItemContent
            title={title}
            description={shortDescription}
            price={item.price}
            calories={item.calories}
            catalogExtendedAttributes={catalog?.extendedAttributes}
          />
        </>
      )}
    </MenuCardNew>
  );
};

export default MenuCardNewItem;
